
export default class DateFormatter{
    static getDate(date){
        date = padDate(date);
        const dateRaw = new Date(date);
        return dateRaw.getDate();
      }
    static getShorthandMonth(date){
        date = padDate(date);
        const shorthandMonths = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const dateRaw = new Date(date);
        return shorthandMonths[dateRaw.getMonth()];
      }
    static getDay(date){
        date = padDate(date);
        const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
        const dateRaw = new Date(date);
        return days[dateRaw.getDay()];
      }

    static getFullMonth(date){
        date = padDate(date);
        const fullMonths = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
        const dateRaw = new Date(date);
        return fullMonths[dateRaw.getMonth()];
    }

    static checkIfTodayOrTomorrow(date){
      const myRegexp = /(.*, )(.*)/g;
      const todayOrTomorrow = ["Today, ", "today, ", "Tomorrow, ", "tomorrow, "];
      const match = date?myRegexp.exec(date):[];
      if(todayOrTomorrow.includes(match[1])){
        return match[1];
      }
    }

    static convertLongMonthToShort(date=""){
      const monthMap = {
        'January': 'Jan', 
        'February': 'Feb', 
         'March': 'Mar', 
         'April': 'Apr', 
         'May': 'May', 
         'June': 'Jun', 
         'July': 'Jul', 
         'August': 'Aug', 
         'September': 'Sep', 
         'October': 'Oct', 
         'November': 'Nov', 
         'December': 'Dec'
      };
      if(typeof date === "string"){
        for(const lm in monthMap){
          date = date.replace(lm, monthMap[lm]);
        }
      }
      return date;
    }

    static convertShortMonthToLong(date=""){
      const monthMap = {
        'Jan':'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sep': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December'
      };
      if(typeof date === "string"){
        for(const lm in monthMap){
          date = date.replace(lm, monthMap[lm]);
        }
      }
      return date;
    }

    static convertShortDayToLong(date=""){
      const dayMap = {
        'Sun':'Sunday',
        'Mon': 'Monday',
        'Tue': 'Tuesday',
        'Wed': 'Wednesday',
        'Thu': 'Thursday',
        'Fri': 'Friday',
        'Sat': 'Saturday',
        'Sun': 'Sunday'
      };
      if(typeof date === "string"){
        for(const day in dayMap){
          date = date.replace(day, dayMap[day]);
        }
      }
      return date;
    }
}


  function padDate(date=""){
    try{
      if(date && date.length===10 && !isIe11()){//2020-03-31
        date = date + ' 00:00:00';
      }
    }catch(e){
      console.error(e);
    }
    return date;
  }

  function isIe11(){
    try{
      return (!!window.MSInputMethodContext && !!document.documentMode);
    }catch(e){
      console.error(e);
    }
  }
